import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';
import ROLES from './TeamMemberConstants';
import { getTooltip } from '../TeamMembers/TeamMembersComponent';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

import './team-member.scss';

const _ = require('lodash');

class TeamMemberComponent extends React.Component {
    render() {
        const { handleSubmit, submitting, isInvalid, updateInvalid } = this.props;

        updateInvalid(isInvalid);

        return <div>
            {submitting && <LoadingComponent fullScreen />}
            <Form onSubmit={handleSubmit} className="team-member">
                <FieldGroupComponent
                    label="Email"
                    name="email"
                    type="text"
                    formProps={{
                        maxLength: 100,
                    }}
                />
                <FieldGroupComponent
                    label="First Name"
                    name="firstName"
                    type="text"
                    formProps={{
                        maxLength: 100,
                    }}
                />
                <FieldGroupComponent
                    label="Last Name"
                    name="lastName"
                    type="text"
                    formProps={{
                        maxLength: 100,
                    }}
                />
                <div className="role">
                    <FieldGroupComponent
                        label="User Role"
                        name="role"
                        placeholder="Select"
                        type="select"
                        formProps={{
                            id: 'role',
                            options: Object.keys(ROLES).map((roleName) => _.capitalize(roleName)),
                        }}
                    />
                    {getTooltip(this)}
                </div>
            </Form>
        </div>
    }
}

TeamMemberComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    isInvalid: PropTypes.bool,
    updateInvalid: PropTypes.func,
};

export default TeamMemberComponent;



// WEBPACK FOOTER //
// ./src/components/profile/TeamMember/TeamMemberComponent.js